import { secrets } from './environment.test.secrets';

export const environment = {
  appUrl: 'bernie-test.bfh.ch',
  production: false,
  backendBaseUrl: 'https://app-bernierdm-test.azurewebsites.net/api',
  loggingBaseUrl: 'https://func-bfh-log-test-c6d7b5hmb5g8e0gp.switzerlandnorth-01.azurewebsites.net/api',
  msalConfig: {
    clientId: '4d86e29d-3e93-4465-9e50-443856d1b8fd',
    authority:
      'https://login.microsoftonline.com/d6a1cf8c-768e-4187-a738-b6e50c4deb4a',
    redirectUri: 'https://bernie-test.bfh.ch',
  },
  version: '1.8.1',
  graphBaseUrl: 'https://graph.microsoft.com/v1.0',
  spoBaseUrl: 'https://bernerfachhochschule.sharepoint.com/sites',
  risBaseUrl: 'https://bfh-ris-service-test.azurewebsites.net/api/v2',
  risKey: secrets.risKey,
  campusAppBaseUrl:
    'https://applink.pocketcampus.org/pcbfh/dashboard/getPluginUrl?pluginId=BfhCmsDeepLinkToNode&redirectUrl=',
  forbiddenChars: '[@\\(\\)\\[\\]"«»\\äöüÄÖÜß?!.:;<>,#%&~*{}/+|]',
  backendClientId: 'f6d798d3-17cc-465f-97ff-f3b770c69d4e',
  frontendClientId: '4d86e29d-3e93-4465-9e50-443856d1b8fd',
  loggingClientId: 'ac897290-b19c-46bc-8571-ad5ca431db60',
  strategicTopics: [
    {
      apiKey: 'none',
      de: 'Kein strategisches Themenfeld',
      fr: 'Aucun domaine thématique stratégique',
      en: 'No strategic thematic field',
    },
    {
      apiKey: 'car-soc',
      de: 'Fürsorgliche Gesellschaft',
      fr: 'Société bienveillante',
      en: 'Caring Society',
    },
    {
      apiKey: 'hum-digit',
      de: 'Humane Digitale Transformation',
      fr: 'Transformation numérique humaine',
      en: 'Humane Digital Transformation',
    },
    {
      apiKey: 'sust-dev',
      de: 'Nachhaltige Entwicklung',
      fr: 'Développement durable',
      en: 'Sustainable development',
    },
  ],
};
